(function () {
  if (window.__l51SiblingsInit) return;
  window.__l51SiblingsInit = true;

  const SECTION_ID = window.PRODUCT_CARD_SECTION_ID || 'api-product-grid-item';
  const SEL_CARD = '[data-grid-item], product-item';
  const SEL_GRID_SIBLING = '[data-sib-grid] .l51-sib-grid__item';

  function getStep(track) {
    if (!track) return 40;
    const item = track.querySelector('.l51-sib-grid__item');
    const gap = parseFloat(getComputedStyle(track).gap || 0);
    return item ? item.getBoundingClientRect().width + gap : 40;
  }

  function getHandleFromUrl(url) {
    try {
      const u = new URL(url, location.origin);
      const parts = u.pathname.split('/').filter(Boolean);
      const i = parts.indexOf('products');
      return i >= 0 ? parts[i + 1] : null;
    } catch {
      return null;
    }
  }

  function updateGridState(root) {
    if (!root) return;

    const track = root.querySelector('[data-sib-grid-track]');
    const prev = root.querySelector('[data-sib-grid-prev]');
    const next = root.querySelector('[data-sib-grid-next]');
    if (!track || !prev || !next) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const left = Math.round(track.scrollLeft);

    if (maxScroll <= 2) {
      root.classList.add('is-static');
    } else {
      root.classList.remove('is-static');
    }

    prev.classList.toggle('is-disabled', left <= 2);
    next.classList.toggle('is-disabled', left >= maxScroll - 2);
  }

  function syncMoreButtonHeight(root) {
    if (!root) return;

    const moreBtn = root.querySelector('[data-sib-pdp-toggle]');
    const firstItem = root.querySelector('.l51-sib-pdp__item');
    if (!moreBtn || !firstItem) return;

    const h = firstItem.offsetHeight;
    if (h > 0) {
      moreBtn.style.height = h + 'px';
    }
  }

  function setPdpToggleState(root, expanded, syncItems = true) {
    if (!root) return;

    const btn = root.querySelector('[data-sib-pdp-toggle]');
    if (!btn) return;

    const countNode = btn.querySelector('.l51-sib-pdp__more-count');
    const textNode = btn.querySelector('.l51-sib-pdp__more-text');
    const moreCount = btn.getAttribute('data-more-count') || '';

    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.classList.toggle('is-less-mode', expanded);

    if (countNode) {
      countNode.textContent = expanded ? `-${moreCount}` : `+${moreCount}`;
    }

    if (textNode) {
      textNode.textContent = expanded ? 'Ver menos' : 'Mostrar';
    }

    if (syncItems) {
      root.querySelectorAll('.is-extra[data-sib-pdp-item]').forEach(function (item) {
        item.hidden = !expanded;
        item.classList.remove('is-collapsing');
        item.style.removeProperty('opacity');
        item.style.removeProperty('transform');
      });
    }
  }

  function animatePdpToggle(root, expand) {
    if (!root) return;

    const grid = root.querySelector('.l51-sib-pdp__grid');
    if (!grid) {
      setPdpToggleState(root, expand);
      syncMoreButtonHeight(root);
      return;
    }

    if (grid.dataset.animating === 'true') return;
    grid.dataset.animating = 'true';

    const extraItems = Array.from(root.querySelectorAll('.is-extra[data-sib-pdp-item]'));
    const duration = 320;

    function cleanup() {
      grid.style.removeProperty('height');
      grid.style.removeProperty('overflow');
      grid.style.removeProperty('transition');
      grid.dataset.animating = 'false';

      extraItems.forEach(function (item) {
        item.classList.remove('is-collapsing');
        item.style.removeProperty('opacity');
        item.style.removeProperty('transform');
        if (!expand) item.hidden = true;
      });

      setPdpToggleState(root, expand, false);
      syncMoreButtonHeight(root);
    }

    if (expand) {
      const startHeight = grid.offsetHeight;

      extraItems.forEach(function (item) {
        item.hidden = false;
        item.style.opacity = '0';
        item.style.transform = 'scale(.96)';
      });

      setPdpToggleState(root, true, false);
      syncMoreButtonHeight(root);

      const endHeight = grid.scrollHeight;

      grid.style.height = startHeight + 'px';
      grid.style.overflow = 'hidden';
      grid.style.transition = 'height 320ms cubic-bezier(.22,.61,.36,1)';
      grid.getBoundingClientRect();

      requestAnimationFrame(function () {
        grid.style.height = endHeight + 'px';

        extraItems.forEach(function (item) {
          item.style.opacity = '1';
          item.style.transform = 'scale(1)';
        });
      });

      const onEnd = function (e) {
        if (e.target !== grid || e.propertyName !== 'height') return;
        grid.removeEventListener('transitionend', onEnd);
        cleanup();
      };

      grid.addEventListener('transitionend', onEnd);

      setTimeout(function () {
        if (grid.dataset.animating === 'true') cleanup();
      }, duration + 120);

      return;
    }

    // CLOSE
    const startHeight = grid.offsetHeight;

    setPdpToggleState(root, false, false);
    syncMoreButtonHeight(root);

    // Medimos altura colapsada sin perder la visual actual
    extraItems.forEach(function (item) {
      item.hidden = true;
    });
    const endHeight = grid.scrollHeight;
    extraItems.forEach(function (item) {
      item.hidden = false;
    });

    grid.style.height = startHeight + 'px';
    grid.style.overflow = 'hidden';
    grid.style.transition = 'height 320ms cubic-bezier(.22,.61,.36,1)';
    grid.getBoundingClientRect();

    requestAnimationFrame(function () {
      extraItems.forEach(function (item) {
        item.classList.add('is-collapsing');
      });

      // dejamos un frame para que el fade empiece antes del colapso
      requestAnimationFrame(function () {
        grid.style.height = endHeight + 'px';
      });
    });

    const onEnd = function (e) {
      if (e.target !== grid || e.propertyName !== 'height') return;
      grid.removeEventListener('transitionend', onEnd);
      cleanup();
    };

    grid.addEventListener('transitionend', onEnd);

    setTimeout(function () {
      if (grid.dataset.animating === 'true') cleanup();
    }, duration + 120);
  }

  function initGrid(root) {
    if (!root || root.dataset.sibReady === 'true') return;
    root.dataset.sibReady = 'true';

    const track = root.querySelector('[data-sib-grid-track]');
    if (!track) return;

    track.addEventListener(
      'scroll',
      function () {
        updateGridState(root);
      },
      { passive: true }
    );

    requestAnimationFrame(function () {
      updateGridState(root);
    });

    setTimeout(function () {
      updateGridState(root);
    }, 80);

    setTimeout(function () {
      updateGridState(root);
    }, 220);
  }

  function initPdp(root) {
    if (!root || root.dataset.sibPdpReady === 'true') return;
    root.dataset.sibPdpReady = 'true';

    setPdpToggleState(root, false);

    requestAnimationFrame(function () {
      syncMoreButtonHeight(root);
    });

    setTimeout(function () {
      syncMoreButtonHeight(root);
    }, 80);
  }

  function initAll(scope) {
    const ctx = scope || document;
    ctx.querySelectorAll('[data-sib-grid]').forEach(initGrid);
    ctx.querySelectorAll('[data-sib-pdp]').forEach(initPdp);
    scheduleEtapasSync();
  }

  async function swapCardFromSibling(linkEl) {
    const card = linkEl.closest(SEL_CARD);
    if (!card) return;

    const siblingUrl = linkEl.getAttribute('href') || '';
    const handle = getHandleFromUrl(siblingUrl);
    if (!handle) return;

    let requestUrl;
    try {
      const u = new URL(siblingUrl, location.origin);
      u.searchParams.set('section_id', SECTION_ID);
      requestUrl = u.toString();
    } catch {
      return;
    }

    card.classList.add('is-loading');

    try {
      const res = await fetch(requestUrl, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newItem = doc.querySelector('[data-grid-item], product-item');
      if (!newItem) return;

      const doSwap = function () {
        if (window.theme?.htmlUpdate?.viewTransition) {
          window.theme.htmlUpdate.viewTransition(card, newItem, []);
        } else {
          card.replaceWith(newItem);
        }

        initAll(newItem);

        requestAnimationFrame(function () {
          newItem.querySelectorAll('[data-sib-grid]').forEach(updateGridState);
          newItem.querySelectorAll('[data-sib-pdp]').forEach(syncMoreButtonHeight);
        });
      };

      requestAnimationFrame(doSwap);
    } catch (err) {
      console.warn('Swap de sibling falló', err);
    } finally {
      card.classList.remove('is-loading');
    }
  }

  async function swapQuickAddFromSibling(linkEl, modal) {
    const href = linkEl.getAttribute('href') || '';
    const handle = getHandleFromUrl(href);
    const optionValueId = linkEl.dataset.optionValueId;
    if (!handle) return;

    const contentEl = modal.querySelector('[data-product-upsell-ajax]');
    if (!contentEl) return;

    modal.classList.add('is-loading');

    try {
      const root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
      const params = new URLSearchParams({ section_id: 'api-product-upsell' });
      const variantId = new URL(href, location.origin).searchParams.get('variant');
      if (variantId) params.set('variant', variantId);

      const res = await fetch(`${root}products/${handle}?${params}`, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newContent = doc.querySelector('[data-api-content]');
      if (!newContent) return;

      contentEl.innerHTML = newContent.innerHTML;
      initAll(contentEl);

      // Talla elegida en la etapa de otro producto: queda seleccionada en el modal recargado.
      // setTimeout para correr después del observer de l51-variant-persist sobre el contenido nuevo
      if (optionValueId) {
        setTimeout(function () {
          preselectNativeOption(contentEl, optionValueId);
        }, 0);
      }
    } catch (err) {
      console.warn('Siblings quick-add swap falló', err);
    } finally {
      modal.classList.remove('is-loading');
    }
  }

  // El popup de la guía de tallas lo renderiza el variant picker del mismo producto
  function findSizeGuideTrigger(el) {
    const scope = el.closest('[data-quick-add-modal], .shopify-section') || document;
    const dialog = scope.querySelector('dialog.modal-size-guide');
    const popup = dialog && dialog.closest('popup-component');
    return popup ? popup.querySelector('[data-popup-open]') : null;
  }

  // Tallas del producto actual en el listado de etapas: seleccionan el radio de <variant-selects>
  // para que el cambio de variante siga el flujo nativo (precio, URL, form, l51-variant-persist).
  // Se ignora el árbol viejo que HTMLUpdateUtility.viewTransition deja con display:none durante el swap.
  const SEL_NATIVE_RADIO = 'variant-selects:not([style*="display: none"]) input[type="radio"]';

  function findNativeOptionInput(chip) {
    const scope = chip.closest('product-info');
    const optionValueId = chip.dataset.optionValueId;
    if (!scope || !optionValueId) return null;

    return scope.querySelector(`${SEL_NATIVE_RADIO}[data-option-value-id="${CSS.escape(optionValueId)}"]`);
  }

  // Se hace click en el label para pasar por los listeners de l51-variant-persist
  function selectNativeOption(input) {
    const wrapper = input.closest('.radio__button');
    const label = wrapper && input.id ? wrapper.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
    (label || input).click();
  }

  function syncEtapas(root) {
    const scope = root.closest('product-info');
    if (!scope) return;

    const checkedIds = new Set(
      Array.from(scope.querySelectorAll(`${SEL_NATIVE_RADIO}:checked`)).map(function (input) {
        return input.dataset.optionValueId;
      })
    );

    root.querySelectorAll('[data-sib-etapa-select]').forEach(function (chip) {
      const isCurrent = checkedIds.has(chip.dataset.optionValueId);
      chip.classList.toggle('is-current', isCurrent);

      if (isCurrent) {
        chip.setAttribute('aria-current', 'true');
      } else {
        chip.removeAttribute('aria-current');
      }
    });
  }

  let etapasSyncRaf = null;
  function scheduleEtapasSync() {
    if (etapasSyncRaf) return;

    etapasSyncRaf = requestAnimationFrame(function () {
      etapasSyncRaf = null;
      document.querySelectorAll('[data-sib-etapas]').forEach(syncEtapas);
    });
  }

  // Talla de otro producto elegida en etapas: al navegar se guarda en sessionStorage y al llegar
  // se selecciona en <variant-selects>, para que el producto abra con esa talla marcada y el botón
  // de agregar habilitado (l51-variant-persist exige elegir talla y no considera ?variant=).
  // Solo aplica a la navegación desde etapas; otros links con ?variant= siguen pidiendo talla.
  const ETAPA_PRESELECT_KEY = 'l51:etapa-preselect';
  const ETAPA_PRESELECT_TTL_MS = 2 * 60 * 1000;

  function preselectNativeOption(scope, optionValueId) {
    const input = scope.querySelector(`${SEL_NATIVE_RADIO}[data-option-value-id="${CSS.escape(optionValueId)}"]`);
    if (!input) return;

    selectNativeOption(input);
    scheduleEtapasSync();
  }

  function rememberEtapaPreselect(link) {
    const href = link.getAttribute('href') || '';
    const optionValueId = link.dataset.optionValueId;
    if (!optionValueId) return;

    try {
      sessionStorage.setItem(
        ETAPA_PRESELECT_KEY,
        JSON.stringify({
          handle: getHandleFromUrl(href),
          variant: new URL(href, location.origin).searchParams.get('variant'),
          optionValueId: optionValueId,
          time: Date.now()
        })
      );
    } catch (err) {
      // Sin sessionStorage disponible se llega sin talla, como antes
    }
  }

  function applyEtapaPreselect() {
    let data = null;

    try {
      data = JSON.parse(sessionStorage.getItem(ETAPA_PRESELECT_KEY) || 'null');
      sessionStorage.removeItem(ETAPA_PRESELECT_KEY);
    } catch (err) {
      return;
    }

    if (!data || Date.now() - data.time > ETAPA_PRESELECT_TTL_MS) return;
    if (getHandleFromUrl(location.href) !== data.handle) return;
    if (new URLSearchParams(location.search).get('variant') !== data.variant) return;

    preselectNativeOption(document, data.optionValueId);
  }

  document.addEventListener('click', function (e) {
    const etapaSelect = e.target.closest('[data-sib-etapa-select]');
    if (etapaSelect) {
      const input = findNativeOptionInput(etapaSelect);
      if (!input) return;

      e.preventDefault();
      selectNativeOption(input);
      scheduleEtapasSync();
      return;
    }

    // Sin talla elegida, l51-variant-persist hace scroll al selector nativo, que está oculto:
    // se redirige al listado de etapas (corre después del scroll de l51, por eso el setTimeout)
    const noSizeBlocker = e.target.closest('.container-no-size');
    if (noSizeBlocker) {
      const scope = noSizeBlocker.closest('product-info') || document;
      const etapas = scope.querySelector('[data-sib-etapas-hide-picker]');
      if (etapas) {
        setTimeout(function () {
          etapas.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 0);
      }
      return;
    }

    const sizeGuideLink = e.target.closest('[data-sib-etapas-guide]');
    if (sizeGuideLink) {
      const trigger = findSizeGuideTrigger(sizeGuideLink);
      if (!trigger) return;

      e.preventDefault();
      trigger.click();
      return;
    }

    const toggleBtn = e.target.closest('[data-sib-pdp-toggle]');
    const prevBtn = e.target.closest('[data-sib-grid-prev]');
    const nextBtn = e.target.closest('[data-sib-grid-next]');
    const siblingLink = e.target.closest(SEL_GRID_SIBLING);
    const sibPdpItem = e.target.closest('[data-sib-pdp-item], [data-sib-etapa-item]');

    if (sibPdpItem) {
      const modal = sibPdpItem.closest('[data-quick-add-modal]');
      if (!modal) {
        if (sibPdpItem.matches('[data-sib-etapa-item]')) rememberEtapaPreselect(sibPdpItem);
        return;
      }

      if (sibPdpItem.classList.contains('is-current')) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      swapQuickAddFromSibling(sibPdpItem, modal);
      return;
    }

    if (toggleBtn) {
      const root = toggleBtn.closest('[data-sib-pdp]');
      if (!root) return;

      const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      animatePdpToggle(root, !expanded);
      return;
    }

    if (prevBtn) {
      const root = prevBtn.closest('[data-sib-grid]');
      const track = root && root.querySelector('[data-sib-grid-track]');
      if (!track) return;

      track.scrollBy({ left: -(getStep(track) * 3), behavior: 'smooth' });
      return;
    }

    if (nextBtn) {
      const root = nextBtn.closest('[data-sib-grid]');
      const track = root && root.querySelector('[data-sib-grid-track]');
      if (!track) return;

      track.scrollBy({ left: getStep(track) * 3, behavior: 'smooth' });
      return;
    }

    if (siblingLink) {
      const inGrid = siblingLink.closest('[data-sib-grid]');
      if (!inGrid) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      swapCardFromSibling(siblingLink);
    }
  }, true);

  let resizeRaf = null;
  window.addEventListener('resize', function () {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(function () {
      document.querySelectorAll('[data-sib-grid]').forEach(updateGridState);
      document.querySelectorAll('[data-sib-pdp]').forEach(function (root) {
        syncMoreButtonHeight(root);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // En DOMContentLoaded ya corrieron los scripts defer que cargan después de este
  // (product-info.js, l51-variant-persist.js) y la talla inicial ya fue limpiada
  let etapaPreselectDone = false;
  function runEtapaPreselect() {
    if (etapaPreselectDone) return;
    etapaPreselectDone = true;
    applyEtapaPreselect();
  }

  if (document.readyState === 'complete') {
    runEtapaPreselect();
  } else {
    document.addEventListener('DOMContentLoaded', runEtapaPreselect);
    window.addEventListener('load', runEtapaPreselect);
  }

  const observer = new MutationObserver(function (mutations) {
    let shouldReinit = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches?.('[data-sib-grid], [data-sib-pdp], [data-grid-item], product-item') ||
          node.querySelector?.('[data-sib-grid], [data-sib-pdp], [data-grid-item], product-item')
        ) {
          shouldReinit = true;
        }
      });
    });

    if (shouldReinit) {
      initAll(document);

      requestAnimationFrame(function () {
        document.querySelectorAll('[data-sib-grid]').forEach(updateGridState);
        document.querySelectorAll('[data-sib-pdp]').forEach(function (root) {
          syncMoreButtonHeight(root);
        });
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Etapas: re-sincroniza la talla marcada cuando cambia el radio nativo, cuando el tema
  // reemplaza <variant-selects> y cuando l51-variant-persist limpia o re-aplica el atributo checked.
  document.addEventListener('change', function (e) {
    if (e.target instanceof HTMLInputElement && e.target.closest('variant-selects')) {
      scheduleEtapasSync();
    }
  });

  const SEL_ETAPAS_SYNC_NODES = 'variant-selects, [data-sib-etapas]';

  const etapasObserver = new MutationObserver(function (mutations) {
    const shouldSync = mutations.some(function (mutation) {
      if (mutation.type === 'attributes') {
        return mutation.target.closest && mutation.target.closest('variant-selects');
      }

      return Array.from(mutation.addedNodes).some(function (node) {
        return node instanceof HTMLElement && (node.matches(SEL_ETAPAS_SYNC_NODES) || node.querySelector(SEL_ETAPAS_SYNC_NODES));
      });
    });

    if (shouldSync) scheduleEtapasSync();
  });

  etapasObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['checked']
  });
})();
